import { inject, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { EnvironmentUrlService } from '../Services/environment-url.services';
// import { VizAuthConfig } from '../public-api';

export const OKTA_CLIENT = new InjectionToken<OktaAuth>('OktaAuth.Client', {
  providedIn: 'root',
  factory: () => {
    const config = inject(EnvironmentUrlService);
    // const router = inject(Router); // todo, make the router dependency optional

    return new OktaAuth({

      logoutUrl: 'http://localhost:4200/',

      pkce: true,
      //These values will be replaced with DEP UI OKTA config
      issuer: config.oktaIssuer,
      clientId: config.oktaClientId,
      redirectUri: '/login/callback',
    });
  },
});
